import { ComparisonPageTemplate } from '@/components/ComparisonPageTemplate'
import { getCompetitor } from '@/data/compare'

export default function WixComparePage() {
  return <ComparisonPageTemplate competitor={getCompetitor('wix')} />
}
